// extracted by mini-css-extract-plugin
module.exports = {"description":"_3X8yDWfDKU8tXjHaUnaljL","pageHeader":"kPiavsJqOxD03UDmUBI8L","icon":"_13fcrALfdQlFldmGRzmtWe","container":"_3JDS_KM48VqdDQMK12npVe"};